import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS = {
  draft: ["Bozza", "bg-gray-100 text-gray-700"],
  scheduled: ["⏳ Programmata", "bg-amber-100 text-amber-800"],
  sending: ["📤 Invio…", "bg-sky-100 text-sky-800"],
  sent: ["✅ Inviata", "bg-green-100 text-green-800"],
  failed: ["❌ Fallita", "bg-red-100 text-red-800"],
};

const localDefault = () => {
  const d = new Date(Date.now() + 3600 * 1000);
  d.setSeconds(0, 0);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

/** Saved newsletters: reload into the form, schedule, send now or delete. */
export const NewsletterDraftsList = ({ drafts, onLoad, onChanged, setError, setSuccess }) => {
  const [scheduling, setScheduling] = useState(null);
  const [when, setWhen] = useState(localDefault);

  const call = async (fn, okMsg) => {
    try {
      const r = await fn();
      if (okMsg) setSuccess(typeof okMsg === "function" ? okMsg(r) : okMsg);
      await onChanged();
    } catch (e) {
      setError(e.response?.data?.detail || "Errore");
    }
  };

  if (!drafts.length) return null;
  return (
    <div className="bg-white p-6 rounded-lg shadow mb-8" data-testid="newsletter-drafts">
      <h3 className="text-lg font-semibold mb-3 text-gray-900">💾 Newsletter salvate</h3>
      <ul className="divide-y">
        {drafts.map((d) => {
          const [label, cls] = STATUS[d.status] || STATUS.draft;
          return (
            <li key={d.id} className="py-2.5 flex flex-wrap items-center gap-2 text-sm" data-testid={`newsletter-draft-${d.id}`}>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${cls}`}>{label}</span>
              <span className="font-medium text-gray-900 truncate flex-1 min-w-[160px]">{d.subject || "(senza oggetto)"}</span>
              <span className="text-xs text-gray-500">
                {d.article_ids?.length ? `${d.article_ids.length} prodotti · ` : ""}
                {d.status === "scheduled" && d.scheduled_at ? `invio ${new Date(d.scheduled_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}` : d.status === "sent" && d.sent_at ? `inviata ${new Date(d.sent_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })} a ${d.result?.sent ?? "?"}` : `salvata ${new Date(d.updated_at).toLocaleDateString("it-IT")}`}
              </span>
              <div className="flex gap-1.5">
                <button type="button" onClick={() => onLoad(d)} className="text-xs px-2 py-1 rounded border hover:bg-gray-50" data-testid={`newsletter-draft-load-${d.id}`}>✏️ Carica</button>
                {d.status !== "sending" && (
                  <>
                    {d.status === "scheduled" ? (
                      <button type="button" onClick={() => call(() => axios.post(`${API}/newsletter/drafts/${d.id}/schedule`, { scheduled_at: null }), "Programmazione annullata")} className="text-xs px-2 py-1 rounded border hover:bg-gray-50" data-testid={`newsletter-draft-unschedule-${d.id}`}>⏹ Annulla invio</button>
                    ) : (
                      <button type="button" onClick={() => setScheduling(scheduling === d.id ? null : d.id)} className="text-xs px-2 py-1 rounded border hover:bg-gray-50" data-testid={`newsletter-draft-schedule-${d.id}`}>🗓️ Programma</button>
                    )}
                    <button type="button" onClick={() => window.confirm(`Inviare ORA "${d.subject}" a tutti gli iscritti?`) && call(() => axios.post(`${API}/newsletter/drafts/${d.id}/send`), (r) => `Newsletter inviata a ${r.data.sent} destinatari`)} className="text-xs px-2 py-1 rounded bg-blue-600 text-white hover:bg-blue-700" data-testid={`newsletter-draft-send-${d.id}`}>📧 Invia ora</button>
                    <button type="button" onClick={() => window.confirm("Eliminare questa newsletter salvata?") && call(() => axios.delete(`${API}/newsletter/drafts/${d.id}`), "Bozza eliminata")} className="text-xs px-2 py-1 rounded border text-red-600 hover:bg-red-50" data-testid={`newsletter-draft-delete-${d.id}`}>🗑</button>
                  </>
                )}
              </div>
              {scheduling === d.id && (
                <div className="w-full flex items-center gap-2 mt-1 pl-1" data-testid={`newsletter-draft-schedule-form-${d.id}`}>
                  <input type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} className="text-sm border rounded px-2 py-1" data-testid="newsletter-draft-schedule-datetime" />
                  <button type="button" onClick={() => call(() => axios.post(`${API}/newsletter/drafts/${d.id}/schedule`, { scheduled_at: new Date(when).toISOString() }), `Invio programmato per ${new Date(when).toLocaleString("it-IT")}`).then(() => setScheduling(null))} className="text-xs px-3 py-1 rounded bg-amber-500 text-white hover:bg-amber-600" data-testid="newsletter-draft-schedule-confirm">Conferma</button>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
